import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import BaseModal from '../BaseModal/Modal';
import BillingIssue from './BillingIssue';

import styles from './PastDue.module.css';

const PastDue = ({ isAccountPastDue }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    setIsModalOpen(isAccountPastDue);
  }, [isAccountPastDue]);

  return (
    <BaseModal
      isOpen={isModalOpen}
      shouldCloseOnOverlayClick={false}
      className={styles.pastDueModal}
    >
      <BillingIssue closeModal={closeModal} />
    </BaseModal>
  );
};

PastDue.propTypes = {
  isAccountPastDue: PropTypes.bool.isRequired,
};

export default PastDue;
